export default "__VITE_ASSET__gXV9gnQZ__"